import {Component, ChangeDetectionStrategy} from '@angular/core';
import {VisitContext} from '../../visit-context';
import {ShipToShipActivity, ShipToShipActivityType} from '@portbase/bezoekschip-service-typescriptmodels';
import moment from 'moment';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-ship-to-ship-activities',
    templateUrl: './ship-to-ship-activities.component.html',
    styleUrls: ['./ship-to-ship-activities.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShipToShipActivitiesComponent {
  context = VisitContext;
  addActivity = () => this.context.visit.securityDeclaration.shipToShipActivities.push(<ShipToShipActivity>{});
  deleteActivity = (activityIdx: number) => this.context.visit.securityDeclaration.shipToShipActivities.splice(activityIdx, 1);
  types: ShipToShipActivityType[] = [ShipToShipActivityType.MISCELLANEOUS, ShipToShipActivityType.CREW_MOVEMENT,
    ShipToShipActivityType.QUARANTINE_INSPECTION, ShipToShipActivityType.UNLOADING_CARGO,
    ShipToShipActivityType.LOADING_CARGO, ShipToShipActivityType.PASSENGER_MOVEMENT,
    ShipToShipActivityType.CARGO_TANK_CLEANING, ShipToShipActivityType.DE_GASSING,
    ShipToShipActivityType.WASTE_DISPOSAL, ShipToShipActivityType.TAKING_BUNKERS, ShipToShipActivityType.CHANGING_CREW,
    ShipToShipActivityType.TAKING_SUPPLIES, ShipToShipActivityType.REPAIR];
  typeFormatter = (type: ShipToShipActivityType) => {
    return type ? formatType(type): null;
  };

  constructor() {
  }

  onShipToShipDrop(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(
        this.context.visit.securityDeclaration.shipToShipActivities,
        event.previousIndex,
        event.currentIndex
      );

      const activity = event.item.data;
      activity.startDate = null;
      activity.endDate = null;
    }
  }

  protected activityNotChronological(activity: ShipToShipActivity){
    return activity.startDate && activity.endDate && moment(activity.startDate).isAfter(moment(activity.endDate));
  }

  protected nextActivityNotChronological(index: number){
    if(index===0){
      return false;
    }
    const activity = this.context.visit.securityDeclaration.shipToShipActivities[index];
    const date = activity.endDate ? activity.endDate : activity.startDate;
    const nextActivity = this.context.visit.securityDeclaration.shipToShipActivities[index-1]
    const nextDate = nextActivity.startDate ? nextActivity.startDate : nextActivity.endDate;
    return date && nextDate && moment(date).isAfter(moment(nextDate))
  }
}

function formatType(type) {
  switch (type) {
    case 'MISCELLANEOUS': return "Miscellaneous";
    case 'CREW_MOVEMENT': return "Crew movement";
    case 'QUARANTINE_INSPECTION': return "Quarantine inspection";
    case 'UNLOADING_CARGO': return "Unloading cargo";
    case 'LOADING_CARGO': return "Loading cargo";
    case 'PASSENGER_MOVEMENT': return "Passenger movement";
    case 'CARGO_TANK_CLEANING': return "Cargo tank cleaning";
    case 'DE_GASSING': return "De-gassing";
    case 'WASTE_DISPOSAL': return "Waste disposal";
    case 'TAKING_BUNKERS': return "Taking bunkers";
    case 'CHANGING_CREW': return "Changing crew";
    case 'TAKING_SUPPLIES': return "Taking supplies";
    case 'REPAIR': return "Repair";
    case 'UNKNOWN': return "Unknown";
    default: throw Error('Unknown ship to ship activity: ' + type);
  }
}
